import React from "react";
import { Box, Typography, Avatar, Container } from "@mui/material";

const ProfileCard = () => {
  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          p: { xs: 2, md: 0 },
          py: { xs: 2, md: 4 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {/* Circular Image with ring */}
        <Box
          sx={{
            mb: 1,
            width: 200,
            height: 200,
            overflow: "hidden",
            borderRadius: "50%",
            position: "relative",
            border: "4px solid transparent",
            background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
          }}
        >
          <Avatar
            alt="Neeraj Verma"
            src={require("../../assets/images/About/About-One.png")}
            sx={{ width: "100%", height: "100%" }}
          />
        </Box>

        {/* Name and Title */}
        <Typography
          variant="h5"
          sx={{
            fontFamily: '"Poppins", serif',
            fontWeight: 600,
            fontSize: { xs: "1.15rem", sm: "1.2rem", md: "1.35rem" },
          }}
        >
          Neeraj Verma
        </Typography>

        <Typography
          variant="subtitle1"
          color="text.secondary"
          sx={{
            mb: 1,
            mt: -0.5,
            fontFamily: '"Poppins", serif',
            fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
          }}
        >
          Co-Founder & CEO
        </Typography>

        {/* Bio */}
        <Typography
          variant="body1"
          sx={{
            textAlign: "justify",
            fontFamily: '"Poppins", serif',
            mb: 1,
            fontSize: { xs: "0.82rem", sm: "0.82rem", md: "0.9rem" },
          }}
        >
          Mr. Neeraj Verma is the CEO and Director of Across Assist Private
          Limited <i>(Formerly Bharti Assist Pvt. Ltd.)</i>.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            textAlign: "justify",
            fontFamily: '"Poppins", serif',
            mb: 1,
            fontSize: { xs: "0.82rem", sm: "0.82rem", md: "0.9rem" },
          }}
        >
          Across Assist, a rapidly growing assurance services company based in
          India. With over 20 years of experience in the banking and financial
          services industry, he has held pivotal roles at esteemed institutions
          such as ICICI Bank, Fullerton India, Citi, and Cholamandalam.​ Under
          his leadership, Across Assist has emerged as a leader in delivering
          innovative, customer-centric assurance solutions across sectors
          including travel, automotive, electronics, and healthcare.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            textAlign: "justify",
            fontFamily: '"Poppins", serif',
            fontSize: { xs: "0.82rem", sm: "0.82rem", md: "0.9rem" },
          }}
        >
          The company boasts a global presence, serving over 200+ countries, and
          has achieved significant milestones such as settling over $1 billion
          in claims and attaining a 4.6/5 customer satisfaction score. In
          recognition of his contributions, Neeraj was honored as one of the "10
          Best CEOs in India 2024" by TradeFlock ,
        </Typography>
      </Box>
    </Container>
  );
};

export default ProfileCard;
